import React, { useCallback, useEffect, useState } from 'react';
import { Col, Label, Row } from 'reactstrap';
import api from "../../../../services/api";
import _ from 'lodash';
import TerminationApprovalDetail from './TerminationApprovalDetail';
import CandidateSelector from '../CandidateSelector';
import { getDefaultSelectedAllocation } from './TerminationUtils';
import TerminationBaseForm from './TerminationBaseForm';

const apiUrl = "termination";

export default function TerminationForm(props) {
    const {
        id,
        approvalId,
        isApproval,
        itemInEdit,
        setItemInEdit,
        setLoading,
        setCanSave,
        setShouldCheckApprover,
        validationObj,
        isFinal,
        footer,
    } = props;

    const [formLoading, setFormLoading] = useState(false);
    const [baseFormLoading, setBaseFormLoading] = useState(false);
    const [selectedAllocationHistoryRows, setSelectedAllocationHistoryRows] = useState([]);
    const [refreshItemInEditForHistory, setRefreshItemInEditForHistory] = useState(false);
    const [defaultEmployeeAssessments, setDefaultEmployeeAssessments] = useState([]);
    const [firstLoad, setFirstLoad] = useState(true);
    const [lookups, setLookups] = useState({});

    useEffect(() => {
        setLoading(formLoading || baseFormLoading);
    }, [formLoading, baseFormLoading]);

    const loadData = useCallback(() => {
        setFormLoading(true);
        
        const apiCalls = [];
        apiCalls.push(api.get(`${apiUrl}/${id}`));
        apiCalls.push(api.get(`${apiUrl}/detail/employeeassessments/${id}`));

        Promise.all(apiCalls)
            .then((responses) => {
                const currentTerminationData = {...responses[0].data};
                const currentEmployeeAssessments = responses[1].data;
                setItemInEdit({
                    ...currentTerminationData,
                });
                setDefaultEmployeeAssessments(currentEmployeeAssessments);
                setShouldCheckApprover(true);
            })
            .catch((error) => console.error({error}))
            .finally(() => setFormLoading(false))
        ;
    }, [id, isApproval]);

    useEffect(() => {
        if (!id)
            return;

        loadData();
    }, [id]);

    useEffect(() => {
        if (!id || !firstLoad || !lookups?.employeeAssessmentItems?.length)
            return;

        setFirstLoad(false);
        setItemInEdit({
            ...itemInEdit,
            terminationAssessmentItems: lookups.employeeAssessmentItems.map(c => {
                const currentEmployeeAssessment = defaultEmployeeAssessments.filter(p => p.employeeAssessmentItemId === c.employeeAssessmentItemId)[0];
                return currentEmployeeAssessment ?? { terminationId: itemInEdit.terminationId, employeeAssessmentItemId: c.employeeAssessmentItemId, employeeAssessmentItemName: c.employeeAssessmentItemName, orderIndex: c.orderIndex, assessmentValue: 0 };
            }),
        })
    }, [lookups?.employeeAssessmentItems]);

    useEffect(() => {
        if (!refreshItemInEditForHistory)
            return;

        setRefreshItemInEditForHistory(false);
        setItemInEdit({
            ...itemInEdit,
            companyId: selectedAllocationHistoryRows[0]?.original?.companyId ?? null,
            company: selectedAllocationHistoryRows[0]?.original?.company ?? null,
            projectId: selectedAllocationHistoryRows[0]?.original?.projectId ?? null,
            project: selectedAllocationHistoryRows[0]?.original?.project ?? null,
            positionId: selectedAllocationHistoryRows[0]?.original?.positionId ?? null,
            position: selectedAllocationHistoryRows[0]?.original?.position ?? null,
        });
        setShouldCheckApprover(true);
    }, [refreshItemInEditForHistory]);

    return (
        <>
            <Row className="m-0 p-0">
                <Col xs={12} className="m-0 p-0">
                {
                    itemInEdit?.terminationId && itemInEdit?.status?.lookupValue !== "Initial" && itemInEdit?.approvalNodeExists ?
                    <Row className="m-0 p-0 p-2 mb-1 border-3 border-secondary w-100">
                        <Label><b>Approval History</b></Label>
                        <TerminationApprovalDetail
                            id={itemInEdit.terminationId}
                        />
                    </Row>
                    :
                    null
                }
                </Col>
            </Row>
            <Row className="m-0 p-0">
                <Col xs={12} className="m-0 p-0">
                    <CandidateSelector
                        setLoading={setFormLoading}
                        data={itemInEdit}
                        apiUrl="employeechangeconditionv2/employee/current"
                        getDefaultSelectedAllocation={(rows) => getDefaultSelectedAllocation(itemInEdit, rows)}
                        onCandidateChanged={({candidateId, candidate, employmentType}) => {
                            setItemInEdit({
                                ...itemInEdit,
                                candidateId: candidateId,
                                candidate: candidate,
                                employmentType: employmentType,
                                employmentTypeId: employmentType?.employmentTypeId,
                            });
                        }}
                        onSelectedAllocationHistoryChanged={(selectedRows) => {
                            setSelectedAllocationHistoryRows(selectedRows);
                            setRefreshItemInEditForHistory(true);
                        }}
                        disabled={isFinal}
                    />
                </Col>
            </Row>
            <TerminationBaseForm
                id={id}
                approvalId={approvalId}
                reloadManagerState={true}
                shouldReload={firstLoad}
                lookups={lookups}
                setLookups={setLookups}
                isApproval={isApproval}
                itemInEdit={itemInEdit}
                setItemInEdit={setItemInEdit}
                setLoading={setBaseFormLoading}
                setCanSave={setCanSave}
                setShouldCheckApprover={setShouldCheckApprover}
                isFinal={isFinal}
                validationObj={validationObj}
                footer={footer}
            />
        </>
    );
};